import React, { useState, useEffect } from "react";
import { Button, Row, Col, Modal, Tooltip, OverlayTrigger, Accordion, Card } from 'react-bootstrap'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery'

const StudentStoryPost = props => {
    const [activityQuestions, setActivityDetail] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalAnswer, setModalAnswer] = useState(null);
    const [answer, setAnswer] = useState([]);
    const [countAnswer1, setCountAnswer1] = useState(0);
    const [attenders, setAttenders] = useState(0);
    const [maxStudent, setMaxStudent] = useState(0);
    const handleActiveIndex = (index) => { if ($(`${index}.card.active`)[0]) { $('.card').removeClass('active'); } else { $('.card').removeClass('active'); $(index).addClass('active'); } };
    const [strengths, setStrengths] = useState([]);
    const [modalShowEndActivity, setModalShowEndActivity] = useState(false);
    const [validateType, setValidateType] = useState(null);
    const [modalAnswerImagePath, setAnswerImagePath] = useState(
        ['/images/icons/student_choose_strength_1.png', '/images/icons/student_choose_strength_2.png', '/images/icons/student_choose_strength_3.png']
    );
    // const { activityId } = useParams();
    const activityId = props.activityId
    const [title, setTitle] = useState('');

    useEffect(() => {
        // setUserRole(AuthService.getUserRole());
        // setUserId(AuthService.getCurrentUserId());

        UserService.getActivityDetail(activityId).then((res) => {
            const questions = [
                res.data.data.topic.questions[0].content,
                res.data.data.topic.questions[1].content,
                res.data.data.topic.questions[2].content,
            ]
            setTitle(res.data.data.topic.title)
            const answerData = [
                {
                    "questionId": res.data.data.topic.questions[0].id,
                    "answerType": "strength",
                    "answer": ["", "", ""]
                },
                {
                    "questionId": res.data.data.topic.questions[1].id,
                    "answerType": "text",
                    "answer": ""
                },
                {
                    "questionId": res.data.data.topic.questions[2].id,
                    "answerType": "text",
                    "answer": ""
                }
            ];
            return { questions: questions, answers: answerData }
        }).then((res) => {
            setActivityDetail(res.questions)
            setAnswer(res.answers)
            UserService.getAnswersByStudentId(activityId, res.answers[1].questionId, AuthService.getCurrentUserId()).then((res) => {
                if (res && res.answer) {
                    window.location.href = `/activity/summary/${activityId}`
                }
            })

        })

        UserService.getStrengths().then((response) => {
            setStrengths(response.data.data)
        });
    }, []);

    if (!window.localStorage.getItem('is-refresh')) {
        window.onpageshow = event => {
            if (event.persisted) {
                window.localStorage.setItem('is-refresh', true);
                window.location.reload();
            }
        }
    } else {
        window.localStorage.removeItem('is-refresh');
    }

    const handleAnswer0 = (strength) => {
        const answerData = [...answer]
        if (answerData.length > 0 && strength.id !== null && strength.imageUrl !== null) {
            answerData[0].answer[modalAnswer] = strength.id
            const answerImagePath = [...modalAnswerImagePath]
            if (answerImagePath.length > 0) {
                const filename = strength.imageUrl.replace(/^.*[\\\/]/, '')
                answerImagePath[modalAnswer] = `/images/strengths/cards/${filename}`
                document.getElementById(`strength-i-${modalAnswer}`).style.display = 'block';
                setAnswerImagePath(answerImagePath)
            }

            console.log(answerData[0].answer[0])

            setAnswer(answerData)
            handleCountAnswer()
        }
    };


    const handleAnswer1 = (event) => {
        const answerData = [...answer]
        if (answerData.length > 0) {
            answerData[1].answer = event.target.value
            setAnswer(answerData)
        }
    };

    const handleAnswer2 = (event) => {
        const answerData = [...answer]
        if (answerData.length > 0) {
            answerData[2].answer = event.target.value
            setAnswer(answerData)
        }
    };

    const handleCountAnswer = () => {
        const answerData = [...answer]
        let count = 0
        for (let index = 0; index < answerData[0].answer.length; index++) {
            if (answerData[0].answer[index] !== "") {
                count++
            }
        }
        setCountAnswer1(count)
    }

    const saveAnswer = () => {
        UserService.postStudentJoinActivity(activityId).then((res) => {
            if (res.data && res.data.status.code === 'SUCCESS') {
                UserService.postActivityAnswer(activityId, answer).then(
                    (res) => {
                        if (res.data && res.data.status.code === 'SUCCESS') {
                            window.location.href = `/activity/summary/${activityId}`
                        }
                    },
                    (error) => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                            AuthService.logout();
                            window.location.href = '/login'
                        } else {
                            alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                        }
                    }
                );
            }
        },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                    AuthService.logout();
                    window.location.href = '/login'
                } else {
                    alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                }
            })
    }

    const clearStrengthAnswer = (index) => {
        const answerData = [...answer]
        answerData[0].answer[index] = ""
        const answerImagePath = [...modalAnswerImagePath]
        document.getElementById(`strength-i-${index}`).style.display = 'none';
        if (index === 0) {
            answerImagePath[index] = "/images/icons/student_choose_strength_1.png"
        } else if (index === 1) {
            answerImagePath[index] = "/images/icons/student_choose_strength_2.png"
        } else if (index === 2) {
            answerImagePath[index] = "/images/icons/student_choose_strength_3.png"
        }
        setAnswerImagePath(answerImagePath)
        setAnswer(answerData)
        handleCountAnswer()
    }

    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className="strength-modal"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row className="py-3 person-choose-strength px-md-4 d-none d-md-flex">
                        {strengths.map((strength, i) => (
                            <div key={i} className="col-12 col-md-4" align="left">
                                {answer[0] && answer[0].answer && answer[0].answer.includes(strength.id) ? (
                                    <div className="position-relative">
                                        <div className="item-overlay w-100 p-1 position-absolute border-radius-5">
                                        </div>
                                        <div className="item my-1 w-100 my-md-2 p-1 border-radius-5 font-sarabun-bold">
                                            <img className="step-img" width="58" src={strength.imageUrl} /> {strength.name}
                                        </div>
                                    </div>
                                ) : (
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 100, hide: 300 }}
                                        overlay={
                                            <Tooltip id="button-tooltip" className='custom-bottom-tooltip' {...props}>
                                                {strength.description}
                                            </Tooltip>
                                        }
                                    >
                                        <div className="item my-1 my-md-2 p-1 click-pointer border-radius-5 font-sarabun-bold" onClick={() => { handleAnswer0(strength); setModalShow(false); }}>
                                            <img className="step-img" width="58" src={strength.imageUrl} /> {strength.name}
                                        </div>
                                    </OverlayTrigger>
                                )}
                            </div>
                        ))}
                    </Row>
                    <Row className="d-flex d-md-none person-collapse">
                        <Col>
                            <Accordion>
                                {strengths.map((strength, i) => (
                                    <Card key={`mobi-${i}`} className={`mobi-${i}`}>
                                        <Accordion.Toggle as={Card.Header} eventKey={i + 1} onClick={() => { handleActiveIndex(`.mobi-${i}`) }}>
                                            <img className="step-img" width="52" src={strength.imageUrl} />  {strength.name}
                                            <div class="arrow">
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </div>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey={i + 1}>
                                            <Card.Body>
                                                <div>
                                                    {strength.description}
                                                </div>
                                                <div align="center">
                                                    <Button className="choose-btn" onClick={() => { handleAnswer0(strength); setModalShow(false); }}
                                                        disabled={answer && answer[0] && (answer[0].answer[0] === strength.id || answer[0].answer[1] === strength.id || answer[0].answer[2] === strength.id)}
                                                    >เลือก</Button>
                                                </div>

                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    const alertEndActivity = () => {
        if (answer[0].answer &&
            answer[0].answer[0] &&
            answer[0].answer[1] &&
            answer[0].answer[2] &&
            answer[1].answer &&
            answer[2].answer) {
            setModalShowEndActivity(true)
        } else {
            setValidateType('answer-warning')
            setModalShowEndActivity(true)
        }
    }
    const handleCloseModal = () => {
        setModalShowEndActivity(false);
        setTimeout(() => { setValidateType(null); }, 500);
    }

    let html = (
        <Row className="blue-bg">
            <Col className="sum-story px-0 blue-bg font-sarabun">
                <Row className="mx-0">
                    <Col className="main-detail px-4">
                        <h2 className="primary-text font-weight-600">{title}</h2>
                    </Col>
                </Row>

                <Row className="pt-3 mx-0">
                    <Col className="primary-text main-detail px-4">
                        <h3 className="pb-0 mb-0 font-weight-600">เลือกตอบ 3 คุณค่าจากนิสัยเชิงบวก ({countAnswer1}/3)</h3>
                    </Col>
                </Row>

                <Row className="py-3 mx-0">
                    <Col className="text-left main-detail px-4">
                        <h4>{activityQuestions[0]}</h4>
                    </Col>
                </Row>
                <Row className="py-3 mx-0">
                    <Col className="main-detail px-4 d-md-flex">
                        <div className="item primary-text col-12 col-md-4 mb-3 position-relative" data-value="1">
                            <img src={modalAnswerImagePath[0]} className="d-inline w-100 click-pointer border-radius-all-16 card-strength-drop-shadow" onClick={() => { setModalShow(true); setModalAnswer(0); }} />
                            <a href="javascript:void(0)" id="strength-i-0" className="clear-image" style={{ 'display': 'none' }} onClick={() => { clearStrengthAnswer(0) }}>X</a>
                        </div>
                        <div className="item primary-text col-12 col-md-4 mb-3 position-relative" data-value="1">
                            <img src={modalAnswerImagePath[1]} className="d-inline w-100 click-pointer border-radius-all-16 card-strength-drop-shadow" onClick={() => { setModalShow(true); setModalAnswer(1); }} />
                            <a href="javascript:void(0)" id="strength-i-1" className="clear-image" style={{ 'display': 'none' }} onClick={() => { clearStrengthAnswer(1) }}>X</a>
                        </div>
                        <div className="item primary-text col-12 col-md-4 mb-3 position-relative" data-value="1">
                            <img src={modalAnswerImagePath[2]} className="d-inline w-100 click-pointer border-radius-all-16 card-strength-drop-shadow" onClick={() => { setModalShow(true); setModalAnswer(2); }} />
                            <a href="javascript:void(0)" id="strength-i-2" className="clear-image" style={{ 'display': 'none' }} onClick={() => { clearStrengthAnswer(2) }}>X</a>
                        </div>
                    </Col>
                </Row>

                <MyVerticallyCenteredModal
                    show={modalShow}
                    onHide={() => { setModalShow(false); setModalAnswer(null); }}
                />

                <Row className="pt-4 pt-md-5 mt-3 bg-white mx-0">
                    <Col className="primary-text main-detail px-4">
                        <h3 className="pb-0 mb-0 font-weight-600">มุมมองของนักเรียนที่มีต่อเรื่องราวนี้</h3>
                    </Col>
                </Row>

                <Row className="py-3 mx-0 bg-white">
                    <Col className="text-left main-detail px-4">
                        <h4>{activityQuestions[1]}</h4>
                    </Col>
                </Row>


                <Row className="py-3 bg-white mx-0">
                    <Col className="main-detail m-md-auto mx-3 px-2 px-md-4">
                        <textarea className="border-radius-12 border-gray p-3 bg-white w-100 text" placeholder="ลองเล่าให้เราฟังหน่อย..." style={{ height: '170px' }} onChange={handleAnswer1} >
                        </textarea>
                    </Col>
                </Row>
                <Row className="mt-0 bg-light-blue mx-0" style={{ 'height': '20px' }} />

                <Row className="pt-4 pt-md-5 bg-white mx-0">
                    <Col className="primary-text main-detail px-4">
                        <h3 className="pb-0 mb-0 font-weight-600">แรงบันดาลใจที่ได้รับจากเรื่องราว</h3>
                    </Col>
                </Row>

                <Row className="py-3  bg-white mx-0">
                    <Col className="text-left main-detail px-4">
                        <h4>{activityQuestions[2]}</h4>
                    </Col>
                </Row>

                <Row className="py-3 bg-white mx-0">
                    <Col className="main-detail m-md-auto mx-3 px-2 px-md-4">
                        <textarea className="border-radius-12 border-gray p-3 bg-white w-100 text" placeholder="ลองเล่าให้เราฟังหน่อย..." style={{ height: '170px' }} onChange={handleAnswer2} >
                        </textarea>
                    </Col>
                </Row>

                <Row className="pb-5 py-md-3 bg-white mx-0">
                    <Col className="main-detail px-4">
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-weight-600" onClick={() => alertEndActivity()}>จบกิจกรรม</Button>
                    </Col>
                </Row>
            </Col >
            <Modal
                show={modalShowEndActivity}
                onHide={() => { handleCloseModal() }}
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >
                {(validateType === 'answer-warning') ? (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>กรุณาตอบคำถามให้ครบด้วยค่ะ</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { handleCloseModal(); }}>กลับกิจกรรม</Button>
                    </Modal.Body>
                ) : (
                    <div>
                        <Modal.Header closeButton className="alert-header">
                        </Modal.Header>
                        <Modal.Body className="font-sarabun text-center pb-4 pt-0">
                            <p id="errorText">คุณต้องการจบกิจกรรมใช่หรือไม่?<br />
                                หากจบกิจกรรมแล้วจะกลับมาแก้ไขอีกไม่ได้ค่ะ</p>
                            <Button className="bluebtn d-inline py-1 py-md-2 px-3 m-1 font-sarabun-bold border-radius-10" onClick={() => { handleCloseModal(); }}>กลับกิจกรรม</Button>
                            <Button className="bluegrey d-inline py-1 py-md-2 px-3 m-1 font-sarabun-bold border-radius-10" onClick={() => saveAnswer()}>ตกลง</Button>

                        </Modal.Body>
                    </div>
                )}
            </Modal>
        </Row>

    );


    return (
        <div className="mx-3">
            {html}
        </div>
    )

}



export default StudentStoryPost